module.exports = __webpack_public_path__ + "img/BioDF-icon.b7b1b311.png";